import { operationSettingType } from '@/constants/operationSetting/option';
export default class ApplyIrregularSurchargeFormDto {
    operationType = operationSettingType.APPLY_IRREGULAR_SURCHARGE;
    isApply;
    hubIds;
    storeIds;
    surchargeReason;
    constructor({ 
    // hub or store
    dialogType, itemIds, 
    // 적용 여부
    isApply, 
    // 할증 사유
    surchargeReason, }) {
        this.isApply = isApply;
        this[`${dialogType}Ids`] = itemIds;
        if (this.isApply) {
            this.surchargeReason = surchargeReason;
        }
    }
    // 보류
    updateViewModelDto() {
        return {
            addChargeApplyYn: this.isApply,
        };
    }
}
